export const HUNTER_SUGGESTIONS = [
  "O que esta drenando minha energia sem que eu perceba?",
  "Qual verdade estou evitando encarar hoje?",
  "Que erro silencioso esta sabotando minha vida?",
  "O que estou adiando por medo disfarçado de prudencia?",
  "Qual habito esta servindo de vampiro na minha rotina?",
  "O que estou tolerando que ja deveria ter cortado?",
  "Qual decisao dificil eu ja sei que preciso tomar?",
  "Onde estou sendo fraco e chamando isso de cansaço?",
  "O que esta consumindo meu foco em silencio?",
  "Qual parte da minha vida esta pedindo ruptura?",
  "Que padrao esta me fazendo perder tempo de vida?",
  "O que estou chamando de destino, mas e omissao?",
  "Que vinculo esta me enfraquecendo por dentro?",
  "Onde estou confundindo conforto com prisao?",
  "Qual medo governa minhas escolhas atuais?",
  "Que area da minha vida esta apodrecendo devagar?",
  "O que eu finjo nao ver para evitar conflito?",
  "Qual pilar da minha vida esta mais fraco hoje?",
  "O que me faz girar em circulos sem avanço real?",
  "Que mentira conveniente estou contando a mim mesmo?",
  "O que esta roubando minha paz sem merecer espaço?",
  "Qual decisao mudaria minha vida se eu a tomasse agora?",
  "Onde estou aceitando menos do que deveria?",
  "O que ja deveria ter terminado e ainda permanece?",
  "Que fraqueza interna esta abrindo a porta ao caos?",
  "O que me prende a uma versao menor de mim?",
  "Qual escolha estou empurrando para o futuro por covardia?",
  "O que precisa morrer em mim para que eu avance?",
  "Que distraçao esta destruindo minha consistencia?",
  "Onde estou desperdiçando força com o inimigo errado?",
  "Qual batalha eu deveria parar de travar?",
  "O que estou alimentando que depois me devora?",
  "Que custo oculto minhas escolhas atuais estao cobrando?",
  "Onde estou sendo ingenuo com algo perigoso?",
  "Qual parte da minha vida exige disciplina imediata?",
  "O que esta me cansando mais do que deveria?",
  "Que decisao tenho medo de assumir publicamente?",
  "Onde esta o verdadeiro foco do meu problema?",
  "O que estou tentando controlar que ja esta perdido?",
  "Qual ciclo precisa ser interrompido agora?",
  "Que pessoa, habito ou ideia esta me drenando?",
  "O que ainda me domina porque eu nunca confrontei?",
  "Onde estou buscando alivio em vez de soluçao?",
  "Qual fraqueza minha os vampiros da vida explorariam primeiro?",
  "O que eu mais preciso enxergar com frieza hoje?",
  "Que ilusao esta me mantendo parado?",
  "O que esta faltando: visao, força, estrutura, fortaleza ou dominio mental?",
  "Qual ferida esta guiando decisoes que parecem racionais?",
  "O que estou chamando de azar, mas e padrao repetido?",
  "Que erro estrategico eu continuo repetindo?",
  "O que deveria ser enfrentado e nao administrado?",
  "Que peso desnecessario estou carregando?",
  "Onde estou sendo lento quando deveria ser firme?",
  "O que me impede de viver a vida que digo querer?",
  "Qual parte da minha historia ainda manda demais em mim?",
  "Que porta eu deveria fechar sem hesitar?",
  "O que esta me mantendo refem da procrastinaçao?",
  "Onde meu silencio esta custando caro?",
  "Que decisao meu futuro exigira que eu tenha tomado agora?",
  "O que minha rotina revela sobre minha fraqueza principal?",
  "Qual batalha interna esta vazando para fora?",
  "O que me faz perder energia antes mesmo do combate?",
  "Que padrao emocional esta deformando meu julgamento?",
  "Onde estou trocando clareza por distraçao?",
  "O que mais me enfraquece quando ninguem esta olhando?",
  "Que escolha pequena esta sabotando grandes resultados?",
  "Onde o medo se disfarçou de logica?",
  "O que ja passou do ponto de ser tolerado?",
  "Qual relaçao esta custando mais do que entrega?",
  "O que esta sugando minha coragem?",
  "Que parte da minha vida precisa de corte, nao de ajuste?",
  "Onde estou insistindo no que ja fracassou?",
  "Qual decisao dura traria paz depois da dor?",
  "O que eu mais evito pensar porque sei o que encontrarei?",
  "Que vicio sutil esta governando meus dias?",
  "Onde estou fraco justamente por falta de ordem?",
  "O que esta implorando por disciplina?",
  "Que desordem interior esta aparecendo no mundo externo?",
  "Qual e o verdadeiro inimigo nesta fase da minha vida?",
  "O que precisa ser encarado antes de qualquer proximo passo?",
  "Onde estou desperdiçando tempo que nao volta?",
  "Que concessao esta corroendo meu respeito proprio?",
  "O que estou aceitando por medo de romper?",
  "Qual ausencia de coragem esta travando meu destino?",
  "O que hoje parece pequeno, mas esta me destruindo aos poucos?",
  "Onde estou sendo dominado por impulso e nao por escolha?",
  "Que verdade cortante eu preciso ouvir agora?",
  "O que precisa ser reorganizado imediatamente em minha vida?",
  "Que erro de visao esta contaminando todas as outras areas?",
  "Onde esta meu ponto cego mais perigoso?",
  "O que esta me impedindo de atravessar este ciclo?",
  "Qual atitude minha alimenta exatamente o que eu condeno?",
  "O que eu deveria eliminar antes de tentar crescer?",
  "Que ruido esta abafando a verdade principal?",
  "Onde meu carater esta sendo testado de verdade?",
  "O que estou protelando e chamando de estrategia?",
  "Qual decisao exige coragem, nao mais analise?",
  "Que parte da minha vida se tornou terreno de vampiros?",
  "Se Van Helsin analisasse minha vida, onde ele mandaria atacar primeiro?",
  "O que em mim precisa despertar antes que seja tarde?",
];

export const AUDIOBOOK_HUNTER_SUGGESTIONS = {
  pt: [
    "de onde vem van helsin",
    "me sinto explorado por tudo isso",
    "esse investimento parece seguro demais para ser verdade",
    "eu continuo abandonando meu plano no meio do caminho",
    "eu entro em panico quando os resultados demoram demais",
    "fui enganado e agora tenho medo de investir de novo",
    "eu continuo gastando para me acalmar",
    "eu desisti de resistir ao sistema",
    "meu dinheiro perde forca antes do fim do mes",
    "eu continuo cometendo o mesmo erro de novo",
    "eu ainda sinto falta de alguem do meu passado",
    "algo vital foi arrancado da minha vida",
    "estou tentando resgatar o que ja se perdeu",
    "eu me apaixonei por uma ideia nao por uma pessoa",
    "cai numa armadilha porque me senti invencivel",
  ],
  en: [
    "where did van helsin come from",
    "i feel exploited by everything around me",
    "this investment sounds too safe to be real",
    "i keep abandoning my plan halfway",
    "i panic when results take too long",
    "i was deceived and now i fear investing again",
    "i keep spending to calm myself down",
    "i gave up resisting the system",
    "my money loses strength before the month ends",
    "i keep making the same mistake again",
    "i still miss someone from my past",
    "something vital was taken from my life",
    "i am trying to rescue what is already lost",
    "i fell in love with an idea not a person",
    "i walked into a trap because i felt unbeatable",
  ],
  es: [
    "de donde viene van helsin",
    "me siento explotado por todo esto",
    "esta inversion parece demasiado segura para ser real",
    "sigo abandonando mi plan a mitad del camino",
    "entro en panico cuando los resultados tardan demasiado",
    "me enganaron y ahora temo invertir otra vez",
    "sigo gastando para calmarme",
    "deje de resistir al sistema",
    "mi dinero pierde fuerza antes de que termine el mes",
    "sigo cometiendo el mismo error otra vez",
    "todavia extrano a alguien de mi pasado",
    "algo vital fue arrancado de mi vida",
    "estoy intentando rescatar lo que ya se perdio",
    "me enamore de una idea no de una persona",
    "cai en una trampa porque me sentia invencible",
  ],
};

function normalizeHunterSuggestionLocale(lang) {
  const raw = String(lang || "").trim().toLowerCase();
  if (raw.startsWith("pt")) return "pt";
  if (raw.startsWith("es")) return "es";
  return "en";
}

export function getHunterSuggestionsByLocale(lang) {
  const locale = normalizeHunterSuggestionLocale(lang);
  const audiobookPool = Array.isArray(AUDIOBOOK_HUNTER_SUGGESTIONS[locale])
    ? AUDIOBOOK_HUNTER_SUGGESTIONS[locale]
    : [];
  if (locale === "pt") {
    return [...HUNTER_SUGGESTIONS, ...audiobookPool];
  }
  return [...audiobookPool];
}

export function getRandomHunterSuggestion(suggestions, current) {
  const pool = Array.isArray(suggestions) ? suggestions.filter(Boolean) : [];
  if (!pool.length) return "";
  if (pool.length === 1) return pool[0];

  let next = pool[Math.floor(Math.random() * pool.length)];
  while (current && next === current) {
    next = pool[Math.floor(Math.random() * pool.length)];
  }
  return next;
}
